import { GraduationCap, Play, Clock, Award, Settings } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Progress } from '../../components/ui/progress';

const cursos = [
  { id: 1, titulo: 'Fundamentos de Oftalmología', duracion: '40 hs', nivel: 'Básico', progreso: 0 },
  { id: 2, titulo: 'Cirugía Refractiva Avanzada', duracion: '60 hs', nivel: 'Avanzado', progreso: 0 },
  { id: 3, titulo: 'Diagnóstico por Imágenes', duracion: '30 hs', nivel: 'Intermedio', progreso: 0 },
  { id: 4, titulo: 'Actualización en Glaucoma', duracion: '25 hs', nivel: 'Intermedio', progreso: 0 },
];

const ELearning = () => {
  return (
    <div className="space-y-6">
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
        <div className="flex items-center gap-3">
          <Settings className="w-5 h-5 text-amber-600" />
          <div>
            <p className="font-medium text-amber-800">Módulo en configuración</p>
            <p className="text-sm text-amber-600">E-Learning estará disponible próximamente. A continuación se muestra una vista previa.</p>
          </div>
        </div>
      </div>

      <div className="opacity-50 pointer-events-none select-none">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-500 mb-2">E-Learning CAO</h1>
          <p className="text-gray-400">Plataforma de cursos y capacitación online</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {cursos.map((curso) => (
            <Card key={curso.id} className="bg-gray-50 border-gray-200">
              <div className="h-32 bg-gray-200 rounded-t-lg flex items-center justify-center">
                <GraduationCap className="w-12 h-12 text-gray-400" />
              </div>
              <CardContent className="p-4">
                <div className="flex gap-2 mb-2">
                  <Badge className="bg-gray-300 text-gray-600">{curso.nivel}</Badge>
                  <Badge variant="outline" className="text-gray-400 border-gray-300">
                    <Clock className="w-3 h-3 mr-1" /> {curso.duracion}
                  </Badge>
                </div>
                <h3 className="font-semibold text-gray-500 mb-3">{curso.titulo}</h3>
                <Progress value={curso.progreso} className="mb-3 bg-gray-200" />
                <Button className="w-full bg-gray-300 text-gray-500" disabled>
                  <Play className="w-4 h-4 mr-2" /> Comenzar
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ELearning;
